(function () {
    //TODO:RESTYLE
    angular
        .module('invesfleet')
        .constant('routes', (function () {
            return {
                ordenesListado: '/flota/ordenes/listado'
            };
        }))
        .constant('constants', (function () {

            var constants = {
                ASEGURADORA_ID_ASSITUR: 0,
                ASEGURADORA_ID_RACC: 1,
                ASEGURADORA_ID_GENERIC: 99
            };

            return constants;
        })())
        .constant('common', (function () {

            var common = {

                changeNulltoBlank(obj) {
                    for (var key in obj) {
                        if (this.isNullOrUndefined(obj[key])) {
                            obj[key] = '';
                        }
                    }
                },
                log(obj) {
                    console.log(obj);
                    return false;
                },
                isNullOrUndefined(obj) {
                    return obj === null || typeof obj === 'undefined';
                },
                uuidv4() {
                    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                    )
                },
                formatDateFromTimestamp(timestamp) {
                    return moment.unix(timestamp).format("DD/MM/YYYY");
                },
                defaultDateRangePickerOptions: { // NOTE: usar $.extend
                    fromDate: moment().subtract(7, "days"),
                    toDate: moment(),
                    options: {
                        locale: {
                            applyLabel: "Aplicar",
                            fromLabel: "Desde",
                            toLabel: "hasta",
                            format: 'DD/MM/YYYY',
                            separator: ' - ',
                            applyLabel: 'Aplicar',
                            cancelLabel: 'Cancelar',
                            weekLabel: 'Sem',
                            customRangeLabel: 'Personalizar',
                            daysOfWeek: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
                            monthNames: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                        },
                        buttonClasses: '',
                        applyClass: 'btn-blue',
                        cancelClass: 'btn-red-invert',
                        opens: 'left',
                        alwaysShowCalendars: true,
                        showDropdowns: true,
                        ranges: {
                            'Hoy': [moment(), moment()],
                            'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                            'Esta semana': [moment().startOf('isoWeek'), moment()],
                            'Últimos 7 días': [moment().subtract(7, 'days'), moment()],
                            'La semana pasada': [moment().subtract(7, 'days').startOf('isoWeek'), moment().subtract(7, 'days').endOf('isoWeek')],
                            'Este mes': [moment().startOf('month'), moment()],
                            'Últimos 30 días': [moment().subtract(30, 'days'), moment()],
                            'El mes pasado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                            'Este año': [moment().startOf('year'), moment()],
                            'Últimos 12 meses': [moment().subtract(1, 'years'), moment()]
                        }
                    }
                },

                timeFormatFilter(seconds) {

                    if (seconds === null) {
                        return '';
                    }

                    var neg = seconds < 0;
                    seconds = Math.abs(seconds);
                    var days = Math.floor(seconds / (3600 * 24));
                    seconds = seconds - (days * (3600 * 24));
                    var hours = Math.floor(seconds / 3600);
                    seconds = seconds - hours * 3600;
                    var minutes = Math.floor(seconds / 60);
                    seconds = seconds - minutes * 60;
                    var sec = Math.floor(seconds);

                    var result = neg ? '-' : '';
                    result += days ? days.toString() + 'd ' : '';
                    if (days < 10) {
                        result += hours ? hours.toString() + 'h ' : '';
                    }
                    if (!days) {
                        result += minutes ? minutes.toString() + 'm ' : '';
                        if (!result) {
                            result += '<1m';
                        }
                    }

                    return result;
                }
            };

            return common;
        })())
        .constant('endPoints', (function () {

            var baseURI = environment.baseUrl;
            var zohoURI = environment.zohoUrl; 
            var legacyBaseURI = environment.legacyBaseUrl;
            var messagingBaseURI = environment.messagingBaseUrl;

            var endPoints = {
                base: baseURI,
                messagingBase: messagingBaseURI,
                messaging: {
                    notifications: messagingBaseURI + '/notifications'
                },
                authorization: {
                    getToken: baseURI + '/connect/token',
                    userInfo: baseURI + '/connect/userinfo',
                },
                fleet: {
                    getMapData: baseURI + '/api/fleet/mapdummy',
                    getActiveOrderById: baseURI + '/api/fleet/GetActiveOrderById',
                    getAssignableOperators: baseURI + '/api/fleet/GetOperatorsForOrder',
                    getRecData: baseURI + '/api/fleet/GetRecorrido',
                    getActiveOrders: baseURI + '/api/fleet/GetActiveOrders',
                },
                orders: {
                    getOrders: baseURI + '/api/orders/',
                    getScheduledOrders: baseURI + '/api/orders/scheduled',
                    activateScheduledOrder: baseURI + '/api/orders/activatescheduledorder',
                    activateScheduledOrders: baseURI + '/api/orders/activatescheduledorders',
                    getOrdenImagenes: baseURI + '/api/orders/GetOrderImages',
                    getOrdenLineas: baseURI + '/api/orders/GetOrdenLineas',
                    getLineasImpuesto: baseURI + '/api/orders/GetLineasImpuesto',
                    addOrdenLinea: baseURI + '/api/orders/AddOrdenLinea',
                    removeOrdenLinea: baseURI + '/api/orders/RemoveOrdenLinea',
                    assignToOperator: baseURI + '/api/fleet/AssignOperatorToOrder',
                    changeAssignmentState: legacyBaseURI + '/ChangeOrderAssignState',
                    updateAssignmentState: baseURI + '/api/orders/ChangeAssigmentState',
                    changeState: legacyBaseURI + '/ChangeOrderState',
                    acknowledgeDelay: baseURI + '/api/orders/AcknowledgeDelay',
                    retarifar: legacyBaseURI + '/retarifar',
                    calcular: legacyBaseURI + '/calcular',
                    removeOrders: baseURI + '/api/orders/Delete',
                    getLogPlanner: baseURI + '/api/orders/GetLogPlannerOrders',
                    getLogPlannerDiv: baseURI + '/api/orders/GetLogPlannerOrdersDiv',
                    splitOrder: baseURI + '/api/orders/SplitOrder',
                    joinOrder: baseURI + '/api/orders/JoinOrder',
					getNewLogisticsCount: baseURI + '/api/orders/GetNewLogisticsCount',
					getAllActiveLogistic: baseURI + '/api/orders/getAllActiveLogistic'
                },
                support: {
                    getInsurerConnectionState: baseURI + '/api/support/GetInsurerCompanyConnections'
                },
                mantenimientoFlotas: {
                    getMantenimientoFlotasByFlotaId: baseURI + '/api/mantenimientoflota/',
                    getAll: baseURI + '/api/mantenimientoflota/getAll'
                },
                genericData: {
                    getGenericData: baseURI + '/api/genericData/'
                },
                preferences: {
                    getCompanyPrefs: baseURI + '/api/preferences/companyPreferences',
                    operatorSates: baseURI + '/api/preferences/operatorSates',
                    getUserPrefs: baseURI + '/api/preferences/userPreferences'
                },
                chat: {
                    getFleetMessages: baseURI + '/api/chat/GetFleetMessages',
                    getFleetUpdates: baseURI + '/api/chat/GetFleetUpdates',
                    ackReceived: baseURI + '/api/chat/AckReception',
                    markAsRead: baseURI + '/api/chat/MarkAsRead',
                    sendMessage: baseURI + '/api/chat/SendFleetMessage'
                },
                report: {
                    getReport: baseURI + '/api/report/',
                    getReportList: baseURI + '/api/report/getReportList'
                },
                entities: {
                    stays: baseURI + '/api/stay/',
                    clients: baseURI + '/api/client/',
                    get: baseURI + '/api/client/GetEntities',
                },
                drivers: {
                    getAllDrivers: baseURI + '/api/driver/getAll',
                    getAllDriversDadosDeBaja: baseURI + '/api/driver/getAllDadosDeBaja',
                    addDrivers: baseURI + '/api/driver/add',
                    getDriver: baseURI + '/api/driver/get',
                    deleteById: baseURI + '/api/driver/deleteById',
                },
                
                user: {
                    getAllUsers: baseURI + '/api/user/getAll',
                    getUsuariosRoles: baseURI + '/api/user/getUsuariosRoles',
                    getUser: baseURI + '/api/user/getUser',
                    getUserCustomInfo: baseURI + '/api/user/getUserCustomInfo',
                    getAllUsuariosDadosDeBaja: baseURI + '/api/user/getAllDadosDeBaja',
                    deleteById: baseURI + '/api/user/deleteById',
                    storeUserData: baseURI + '/api/user/storeUserData',
                    saveConfig: baseURI + '/api/user/SaveConfig',
                    add: baseURI + '/api/user/Add'
                },
                vehicles: {
                    getAllVehicles: baseURI + '/api/vehicle/getAll',
                    getAllVehiclesDadosDeBaja: baseURI + '/api/vehicle/getAllDadosDeBaja',
                    deleteById: baseURI + '/api/vehicle/deleteById',
                    getFlota: baseURI + '/api/vehicle/getFlota',
                    addVehicles: baseURI + '/api/vehicle/add',
                },
                colectivos: {
                    getAll: baseURI + '/api/colectivo/getAll',
                },
                zonas: {
                    getAll: baseURI + '/api/zona/getAll',
                    pointInZone: baseURI + '/api/zona/pointInZone',
                },
                empresas: {
                    getAll: baseURI + '/api/empresa/getAll',
                },
                colaboradores: {
                    getAll: baseURI + '/api/colaborador/getAll',
                },
                talleres: {
                    getList: baseURI + '/api/taller/GetList',
                    add: baseURI + '/api/taller/Add',
                    getById: baseURI + '/api/taller/GetById',
                    deleteById: baseURI + '/api/taller/DeleteById',
                },
                estadoOperario: {
                    getList: baseURI + '/api/estadosOperario/GetList',
                    add: baseURI + '/api/estadosOperario/Add',
                    getById: baseURI + '/api/estadosOperario/GetById',
                    deleteById: baseURI + '/api/estadosOperario/DeleteById',
                },
                tipoOrden: {
                    getList: baseURI + '/api/tipoOrden/GetList',
                    add: baseURI + '/api/tipoOrden/Add',
                    getById: baseURI + '/api/tipoOrden/GetById',
                    deleteById: baseURI + '/api/tipoOrden/DeleteById',
                },
                mantenimientoFlotaTipos: {
                    getList: baseURI + '/api/mantenimientoFlotaTipo/GetList',
                    add: baseURI + '/api/mantenimientoFlotaTipo/Add',
                    getById: baseURI + '/api/mantenimientoFlotaTipo/GetById',
                    deleteById: baseURI + '/api/mantenimientoFlotaTipo/DeleteById',
                },
                mensajesPredef: {
                    getList: baseURI + '/api/mensajePredef/GetList',
                    add: baseURI + '/api/mensajePredef/Add',
                    getById: baseURI + '/api/mensajePredef/GetById',
                    deleteById: baseURI + '/api/mensajePredef/DeleteById',
                },
                grupos: {
                    getList: baseURI + '/api/grupo/GetList',
                    add: baseURI + '/api/grupo/Add',
                    getById: baseURI + '/api/grupo/GetById',
                    deleteById: baseURI + '/api/grupo/DeleteById',
                },
                puntosInteres: {
                    getAll: baseURI + '/api/puntoInteres/getAll',
                },
                alarmas: {
                    getAll: baseURI + '/api/alarma/getAll',
                },
                tarifas: {
                    getFields: baseURI + '/api/tarifa/GetFields',
                    addTarifa: baseURI + '/api/tarifa/AddTarifa',
                    getList: baseURI + '/api/tarifa/GetList',
                    getTarifa: baseURI + '/api/tarifa/GetTarifaById',
                },
                aseguradoras: {
                    getAseguradoras: baseURI + '/api/aseguradoras/getInsurerCompanyConnections',
                    updateAseguradorasConnexion: baseURI + '/api/aseguradoras/updateConnexionColaboradorAseguradora',
                    getConnexionEmpresaMaster: baseURI + '/api/aseguradoras/getConnexionEmpresaMaster',
                    updateConnexionEmpresaMaster: baseURI + '/api/aseguradoras/updateConnexionEmpresaMaster',
                },
                perfilFlota: {
                    getAll: baseURI + '/api/perfilFlota/GetAll',
                    getById: baseURI + '/api/perfilFlota/GetById',
                    deleteById: baseURI + '/api/perfilFlota/DeleteById',
                    add: baseURI + '/api/perfilFlota/Add',
                    update: baseURI + '/api/perfilFlota/Update',
                },
                productos: {
                    getList: baseURI + '/api/productos/GetList',
                    add: baseURI + '/api/productos/AddProduct',
                    get: baseURI + '/api/productos/GetProduct',
                    deleteById: baseURI + '/api/productos/deleteById',
                },
                bases: {
                    getList: baseURI + '/api/baseFlota/GetList',
                    add: baseURI + '/api/baseFlota/Add',
                    getById: baseURI + '/api/baseFlota/GetById',
                    deleteById: baseURI + '/api/baseFlota/DeleteById',
                },
                colores: {
                    getList: baseURI + '/api/color/GetList',
                    add: baseURI + '/api/color/Add',
                    getById: baseURI + '/api/color/GetById',
                    deleteById: baseURI + '/api/color/DeleteById',
                },
                logEmpleados: {
                    getPending: baseURI + '/LogEmpleados/GetPending',
                    getArchivadas: baseURI + '/LogEmpleados/GetArchivadas',
                    getActive: baseURI + '/LogEmpleados/getActive',
                    getAccepted: baseURI + '/LogEmpleados/GetAccepted', 
                    getDriversNum: baseURI + '/LogEmpleados/GetDriversNum', 
                    aprobar: baseURI + '/LogEmpleados/Aprobar', 
                    archivar: baseURI + '/LogEmpleados/Archivar',
                    desarchivar: baseURI + '/LogEmpleados/Desarchivar',
                    getAll: baseURI + '/LogEmpleados/getAll', 
                    getPendingNum: baseURI + '/LogEmpleados/getPendingNum', 
                    getAvailable: baseURI + '/LogEmpleados/getAvailable' , 
                    getById: baseURI + '/LogEmpleados/getById', 
                    getMyById: baseURI + '/LogEmpleados/getMyById',
                    getEmpleados: baseURI + '/LogEmpleados/getEmpleados', 
                    getAllEmpleados: baseURI + '/LogEmpleados/getAllEmpleados',
                    getGruposEstado: baseURI + '/LogEmpleados/getGruposEstado', 
                    save: baseURI + '/LogEmpleados/save', 
                    suscriptionHorarioUpdate: baseURI + '/LogEmpleados/suscriptionHorarioUpdate',
                    getJornadasEmpleado: baseURI + '/LogEmpleados/GetJornadasEmpleado',
                    aceptarJornadas: baseURI + '/LogEmpleados/AceptarJornadas',
                    rechazarJornada: baseURI + '/LogEmpleados/RechazarJornada',
                    changeEstadoJornada: baseURI + '/LogEmpleados/ChangeEstadoJornada', 
                    getZoho: zohoURI + '/get_company_subscriptions', 
                    updateZoho: zohoURI + '/update_company_subscription', 
                    deleteZoho: zohoURI + '/delete_company_subscription', 
                    createZoho: zohoURI + '/create_company_subscription', 



                },
                empleados: {
                    getAll: baseURI + '/Empleados/getAll',
                    getById: baseURI + '/Empleados/getById',
                    createUpdateContrato: baseURI + '/Empleados/createUpdateContrato', 
                    getContratos: baseURI + '/Empleados/getContratos', 
                    deleteContrato: baseURI + '/Empleados/deleteContrato', 
                    saveEmpleado: baseURI + '/Empleados/saveEmpleado', 
                    getSupervisores: baseURI + '/Empleados/getSupervisores'
                },
                averias: {
                    getList: baseURI + '/api/averia/GetList',
                    add: baseURI + '/api/averia/Add',
                    getById: baseURI + '/api/averia/GetById',
                    deleteById: baseURI + '/api/averia/DeleteById',
                },
                reporting: {
                    showInform: baseURI + '/reporting/UserReport',
                    saveReport: baseURI + '/reporting/SaveReport',
                    getFields: baseURI + '/reporting/GetFields',
                    getFilters: baseURI + '/reporting/GetFilters',
                    getRelations: baseURI + '/reporting/GetRelations',
                    testReport: baseURI + '/reporting/TestReport',
                    testCloned: baseURI + '/reporting/TestCloned',
                    saveCloned: baseURI + '/reporting/SaveCloned',
                    showReport: baseURI + '/reporting/ShowReport',
                    showPredeterminated: baseURI + '/reporting/ShowPredeterminated',
                    showFacturasCliente: baseURI + '/reporting/ShowFacturasCliente',
                    getReports: baseURI + '/reporting/GetReports',
                    getFavorites: baseURI + '/reporting/GetFavorites',
                    getById: baseURI + '/reporting/GetById',
                    deleteReport: baseURI + '/reporting/DeleteReport',
                    exportReport: baseURI + '/reporting/ExportReport',
                    getPredeterminatedFilters: baseURI + '/reporting/GetPredeterminatedFilters',
                    consumoCombustible: baseURI + '/reporting/ConsumoCombustible',
                    combustibleRespectoTotal: baseURI + '/reporting/CombustibleRespectoTotal',
                    showFichaje: baseURI + '/reporting/ShowFichaje',
                    getEmpleados: baseURI + '/reporting/getEmpleados',
                    exportFichaje: baseURI + '/reporting/ExportFichajePruebas',
                    showServicios: baseURI + '/reporting/showServices',
                    exportServicios: baseURI + '/reporting/ExportServicios',
                    getEmpresas: baseURI + '/reporting/getEmpresas',

                },
                GOOGLE_MAPS_API_URL: 'https://maps.googleapis.com/maps/api/js?client=gme-investeltechnologies',
            };

            return endPoints;
        })());
})();